import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "../../../components/standardElements";
import ConfirmModal from "../../../components/ConfirmModal";
import { COLORS } from "../../../helpers/designConstants";

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const ControlButton = styled(Button)`
  justify-content: center;
  min-height: 44px;
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    min-height: 48px;
    font-size: 16px;
  }
`;

const OptionsContainer = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${COLORS.border};
`;

const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${COLORS.textSecondary};
  margin-bottom: 8px;
  cursor: pointer;
`;

const OptionCheckbox = styled.input`
  margin: 0;
`;

const StatusText = styled.p`
  font-size: 14px;
  color: ${COLORS.textSecondary};
  margin: 0;
  text-align: center;
`;

const AdminControls = ({ 
  onTriggerRun, 
  isRunning, 
  isLoading 
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [runOptions, setRunOptions] = useState({
    forceRefresh: false
  });

  const handleTriggerRun = async () => {
    setShowConfirmModal(false);
    try {
      await onTriggerRun(runOptions);
    } catch (error) {
      // Error handling is done in the hook
    }
  };

  const handleOptionChange = (option, value) => {
    setRunOptions(prev => ({
      ...prev,
      [option]: value
    }));
  };

  return (
    <ControlsContainer>
      <ControlButton
        onClick={() => setShowConfirmModal(true)}
        disabled={isRunning || isLoading}
        style={{
          backgroundColor: isRunning ? COLORS.warning : COLORS.primary,
          opacity: isRunning || isLoading ? 0.6 : 1
        }}
      >
        {isRunning ? "Parser Running..." : "Run Data Parser Now"}
      </ControlButton>


      {isRunning && (
        <StatusText>
          Data parser is currently running. Please wait for completion.
        </StatusText>
      )}

      <OptionsContainer>
        <OptionLabel>
          <OptionCheckbox
            type="checkbox"
            checked={runOptions.forceRefresh}
            onChange={(e) => handleOptionChange("forceRefresh", e.target.checked)}
          />
          Force refresh cached data
        </OptionLabel>
      </OptionsContainer>

      <ConfirmModal
        show={showConfirmModal}
        title="Confirm Manual Run"
        buttonTitle="Run Parser"
        message={
          <div>
            <p>Are you sure you want to manually trigger the data parser?</p>
            <br />
            <p><strong>Options:</strong></p>
            <ul style={{ margin: "8px 0", paddingLeft: "20px" }}>
              {runOptions.forceRefresh && <li>Force refresh cached data</li>}
            </ul>
            <br />
            <p style={{ color: COLORS.warning }}>
              This will process the entire inventory and may take several minutes.
            </p>
          </div>
        }
        onConfirm={handleTriggerRun}
        onClose={() => setShowConfirmModal(false)}
      />
    </ControlsContainer>
  );
};

export default AdminControls;